"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardDetails = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _offerStyles = require("../common/offer-styles");

var _detailsTabs = require("../common/details-tabs");

var _ratesAndFees = require("./rates-and-fees");

var _details = require("./details");

var _qualifiers = require("./qualifiers.js");

var _recommendation = require("./recommendation");

var _termsConditions = require("./terms-conditions");

var _offerLinkAttributes = require("../util/offer-link-attributes");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GetStarted = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "GetStarted",
  componentId: "sc-122oxr9-0"
})(["margin-top:8px;"]);

var CardDetails = function CardDetails(_ref) {
  var _creditCardOffer$navE, _creditCardOffer$navE2, _creditCardOffer$appl;

  var creditCardOffer = _ref.creditCardOffer,
      shouldShowQualifiers = _ref.shouldShowQualifiers,
      onApplyTrack = _ref.onApplyTrack,
      shouldHideSignup = _ref.shouldHideSignup,
      shouldHideApply = _ref.shouldHideApply;

  var _useState = (0, _react.useState)(shouldShowQualifiers ? 'Qualification Requirements' : 'Rates and Fees'),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      shownTab = _useState2[0],
      setShownTab = _useState2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.AdditionalDetails, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_detailsTabs.DesktopTabGroup, {
      children: [shouldShowQualifiers && /*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsTabs.DesktopTab, {
        title: "Qualification Requirements",
        shownTab: shownTab,
        handleShownTab: setShownTab
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsTabs.DesktopTab, {
        title: "Rates and Fees",
        shownTab: shownTab,
        handleShownTab: setShownTab
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsTabs.DesktopTab, {
        title: "Details",
        shownTab: shownTab,
        handleShownTab: setShownTab
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsTabs.DesktopTab, {
        title: "Our Recommendation",
        shownTab: shownTab,
        handleShownTab: setShownTab
      }), ((_creditCardOffer$navE = creditCardOffer.navEditorial) === null || _creditCardOffer$navE === void 0 ? void 0 : _creditCardOffer$navE.termsAndConditions) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsTabs.DesktopTab, {
        title: "Terms & Conditions",
        shownTab: shownTab,
        handleShownTab: setShownTab
      })]
    }), shouldShowQualifiers && /*#__PURE__*/(0, _jsxRuntime.jsx)(_qualifiers.Qualifiers, {
      creditCardOffer: creditCardOffer,
      shownTab: shownTab,
      handleShownTab: setShownTab
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ratesAndFees.RatesAndFees, {
      creditCardOffer: creditCardOffer,
      shownTab: shownTab,
      handleShownTab: setShownTab
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_details.Details, {
      creditCardOffer: creditCardOffer,
      shownTab: shownTab,
      handleShownTab: setShownTab
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recommendation.Recommendation, {
      creditCardOffer: creditCardOffer,
      shownTab: shownTab,
      handleShownTab: setShownTab
    }), ((_creditCardOffer$navE2 = creditCardOffer.navEditorial) === null || _creditCardOffer$navE2 === void 0 ? void 0 : _creditCardOffer$navE2.termsAndConditions) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_termsConditions.TermsConditions, {
      creditCardOffer: creditCardOffer,
      shownTab: shownTab,
      handleShownTab: setShownTab
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.DetailsFooter, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.ApplyButton, Object.assign({
        asAnchor: true,
        disabled: shouldHideApply,
        rel: "noopener noreferrer",
        target: "_blank",
        size: "large"
      }, (0, _offerLinkAttributes.offerLinkAttributes)(shouldHideApply ? null : (_creditCardOffer$appl = creditCardOffer.applyUrl) !== null && _creditCardOffer$appl !== void 0 ? _creditCardOffer$appl : ''), {
        "data-testid": "loancard-v2:apply-button",
        onClick: onApplyTrack,
        children: "Apply now"
      })), !shouldHideSignup && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.SignUp, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          bold: true,
          children: "Want to find out how you match up to this offer?"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          children: "Business owners who get matched through Nav are 3.5x more likely to get approved."
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(GetStarted, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Link, {
            target: "_blank",
            rel: "noreferrer",
            href: "https://app.nav.com/registration/",
            children: "Get Started"
          })
        })]
      })]
    })]
  });
};

exports.CardDetails = CardDetails;
//# sourceMappingURL=card-details.js.map